import React from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Retailer from "../../components/Retailer";
import Firebase from "../../firebasehelper";
import "./index.css";
import FilterTab from "../super_offers/components/FilterTab";
import { TerritoryOptions } from "../../Constants/retailer";

class Retailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      deactive: [],
      tag: "Top 20",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          territory: res.territory || TerritoryOptions[0],
          hex: res.hex,
          loading: false,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
        });
      });
    }
    Firebase.getAllDeactiveRetailers((res) => {
      let deactive = [];
      if (res) deactive = res;
      this.setState({ deactive });

      Firebase.getAllRetailers((res) => {
        const keys = Object.keys(res).filter((obj) => !deactive[obj]);
        const wgRetailers = keys
          .map((key) => ({
            ...res[key],
            id: key,
          }))
          .filter((r) => r.ecopayRetailer);
        Firebase.getAllNCRetailers((res) => {
          const keys = Object.keys(res);
          const ncRetailers = keys
            .map((key) => ({
              ...res[key],
              id: key,
            }))
            .filter((r) => r.isActive);
          const retailers = [...wgRetailers, ...ncRetailers];
          retailers.sort((a, b) => {
            var textA = a.retailerName.toUpperCase();
            var textB = b.retailerName.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });
          this.setState({ retailers });
        });
      });
    });
  }

  filter_View = (tag) => {
    this.setState({ tag });
  };

  showRetailers = () => {
    const { retailers, deactive, tag } = this.state;
    let username = this.props.location.state.username;
    // let filteredRetailerKeys = Object.keys(retailers).filter(
    //   (obj) => !deactive[obj]
    // );
    // if (tag) {
    //   filteredRetailerKeys = filteredRetailerKeys.filter((key) => {
    //     const item = retailers[key];
    //     if (tag === "Top 20" && item.top20 && item.top20 !== "none")
    //       return true;
    //     return item.retailerType === tag;
    //   });
    // }
    return retailers.map((retailer, index) => {
      const territory = retailer.territory || TerritoryOptions[0];
      if (territory !== this.state.territory) {
        return null;
      }
      return (
        <Retailer
          readOnly
          key={index}
          // deactive={deactive[index] ? "deactive" : "activate"}
          isSuper={false}
          username={username}
          retailer={retailer}
          retailers={retailers}
          onClick={() => {
            console.log("-=-=-=-=", retailer);
          }}
          mode={1}
          id={retailer.id}
        />
      );
    });
  };

  render() {
    const { retailers, logo, brand, brand_name, is_property_brand, tag } =
      this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="content">
            {Object.keys(retailers).length ? (
              <React.Fragment>
                {/* <FilterTab filter_View={this.filter_View} tag={tag} /> */}
                {this.showRetailers()}
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
        </main>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapActionToProps)(Retailers);



// WEBPACK FOOTER //
// ./src/screens/Retailers/index.js